// NOTE: see examples directory for a list of possible examples to include
export const examples = [
  { name: 'JSCAD Logo', source: './examples/jscad.example.js' },
  { name: 'Primitive Shapes', source: './examples/primitives.example.js' },
  { name: 'Basic Booleans', source: './examples/booleans.example.js' },
  { name: 'Extrusions', source: './examples/extrusions.example.js' },
  { name: 'Hull Operations', source: './examples/hulls.example.js' },
  { name: 'Alignments', source: './examples/alignments.example.js' },
  { name: 'Parametric Gear', source: './examples/gear.example.js' },
  { name: 'Nuts and Bolts', source: './examples/nuts-and-bolts.example.js' },
  { name: 'Text Shapes', source: './examples/text.example.js' },
  { name: 'Parameter Types', source: './examples/parameters.example.js' },
  // { name: 'Import 3MF', source: './examples/3MFImport/index.js' },
  { name: 'Import STL', source: './examples/STLImport/index.js' },
  { name: 'Import SVG', source: './examples/SVGImport/index.js' },
]
